<template>
  <el-card>
    <div slot="header" class="card-header">
      <div>{{factoryInfo?factoryInfo.name:''}}库存情况</div>
    </div>
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      @selection-change="dataListSelectionChangeHandle"
      style="width: 100%"
    >
      <el-table-column
        type="index"
        header-align="center"
        align="center"
        width="50"
        label="行号"
      ></el-table-column>
      <el-table-column
        prop="code"
        label="品番号"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="产品名称"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="color"
        label="颜色"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="size"
        label="尺寸"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="attr1"
        label="规格"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="attr2"
        label="其他"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="count"
        label="数量"
        header-align="center"
        align="center"
      ></el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/factorystore/page",
        getDataListIsPage: true,
        deleteIsBatch: true,
        activatedIsNeed: false,
      },
      dataForm: {
        factoryId: "",
      },
      factoryInfo: {},
    };
  },
  activated() {
    this.dataForm.factoryId = this.$route.query.factoryId;
    if (this.dataForm.factoryId) {
      this.getDataList();
      this.getInfo()
    }
  },
  methods: {
    getInfo() {
      this.$http
        .get(`/trade/factory/${this.dataForm.factoryId}`)
        .then(({ data: res }) => {
          this.factoryInfo = {
            ...res.data,
          };
        });
    },
  },
};
</script>
